import aiEdgeExpertLogo from '@assets/ai-edge-expert_1758918621078.png'

export default function Footer() {
  return (
    <footer className="bg-white dark:bg-white border-t border-gray-200 py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center space-y-4">
          {/* Company Logo */}
          <a
            href="https://members.aiedge.ac"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-80"
            data-testid="footer-logo-link"
          >
            <img
              src={aiEdgeExpertLogo}
              alt="AI Edge Expert"
              className="h-10 w-auto"
            />
          </a>

          {/* Disclaimer */}
          <p className="text-sm text-gray-600 text-center italic">
            For educational purposes only. May produce inaccurate results. Use at your own risk.
          </p>
        </div>
      </div>
    </footer>
  )
}